import React from 'react';

export const Logo = () =>
  <div style={{ margin: '0rem auto', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center'}}>
    <a href="https://cms.bibletraditions.org/" target="_blank" rel="noopener noreferrer">
      <img
        src="https://cms.bibletraditions.org/public/img/logo_med_en.png" alt="bible.in.its.traditions logo"
        style={{ width: `150px`, margin: ".5em auto .3em" }}
      />
    </a>
  </div>;

export const URL_API_COLLABORATOR = 'https://ga9ym2wjab.execute-api.us-east-1.amazonaws.com/p/collaborator';

export const URL_API_S3SIGNER = 'https://9akx05li13.execute-api.us-east-1.amazonaws.com/p/s3signing';

export const URL_API_LISTS3BUCKET = ' https://9akx05li13.execute-api.us-east-1.amazonaws.com/p/listmedia'



// WEBPACK FOOTER //
// ./src/Utils.js